import type { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { Locations } from '../types/locations.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { Locations };

const getEndPointUrl = (numberOfRecentProjects: number) => {
	const sortByRecent = numberOfRecentProjects ? `sortByRecent=${numberOfRecentProjects}` : '';
	return `/rest/greenhopper/1.0/boardLocation.json?${sortByRecent}`;
};

const getLocations$ = (numberOfRecentProjects: number): Observable<Locations> =>
	fetchJson$(getEndPointUrl(numberOfRecentProjects)).map((payload) => ({
		// @ts-expect-error - TS2571 - Object is of type 'unknown'.
		projects: payload.projects,
		// @ts-expect-error - TS2571 - Object is of type 'unknown'.
		user: payload.user,
	}));

export default getLocations$;
